// @flow
import React from 'react';
import { useQuery } from 'urql';
import DwellTracking from '@ta/cpm.dwell-tracking';
import HomeDMOQuery, { type PlatformEnumInput } from './HomeDMOQuery.gql';

type Props = {
  geoId: number,
  locale: string,
  platform: PlatformEnumInput,
};

export default function DmoDwellTracking(props: Props) {
  const { geoId = 1, locale = '', platform } = props;
  const [{ fetching: loading, data }] = useQuery({
    query: HomeDMOQuery,
    variables: { geoId, locale, platform },
  });

  const profileId = (data && data.sponsoredHome?.profile?.id) || '';
  const enableShelfAndAlbum = data && data.sponsoredHome?.enableShelfAndAlbum;
  const profileName = `DMO_${profileId}_${locale}_${platform}`;

  return !loading && !enableShelfAndAlbum ? null : (
    <DwellTracking profileName={profileName} trackingId={geoId} isSponsored />
  );
}
